/// <amd-module name="Artifacts/Nuget/commands/UpstreamOverride" />

import { NugetActions } from "Artifacts/Nuget/redux";
import { getUpstreamOverrideCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createUpstreamOverrideCommand = getUpstreamOverrideCommandCreator(
  NugetActions.setUpstreamOverride,
);
